import React from 'react';
import PropTypes from 'prop-types';
import { Content, Base } from './ButtonFilter.styles';

export const ButtonFilter = ({ value, borderColor, onClick, ...rest }) => (
    <Base borderColor={borderColor} onClick={onClick}>
        <Content {...rest}>{value}</Content>
    </Base>
);

ButtonFilter.displayName = 'ButtonFilter';

ButtonFilter.propTypes = {
    value: PropTypes.string.isRequired,
    borderColor: PropTypes.string,
};

ButtonFilter.defaultProps = {
    borderColor: 'red',
};
